<template>
  <div v-if="displayTimerBar" :style="{ backgroundColor: backgroundColor, color: textColor }"
       :class="`timer rounded ${isDailyDeal ? 'p-3 dailyDealBanner' : 'homePageBanner'}`">
    <div
      :class="`container d-flex flex-column flex-md-row ${isDailyDeal ? 'justify-content-between justify-content-lg-center' : 'justify-content-center'} align-items-center`">
      <!-- Content -->
      <div v-if="enableContent && isDailyDeal" class="mt-md-0 align-self-center mb-2">
        <slot name="content"></slot>
      </div>

      <!-- Daily Deal Layout -->
      <div v-if="isDailyDeal" class="daily-deal-container">
        <!-- Mobile: DAILY DEAL on first row, timer on second row -->
        <div class="mobile-layout">
          <div class="daily-deal-title">DAILY DEAL</div>
          <div class="timer-row">
            <div v-if="!isDailyDeal" class="timer-item">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Days</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ days }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Hours</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ hours }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Minutes</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ minutes }}</div>
            </div>
            <div class="timer-item">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Seconds</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ seconds }}</div>
            </div>
          </div>
          <div v-if="enableClose" class="close-icon-mobile">
            <i class="las la-times la-m2x" style="cursor: pointer" @click="close"></i>
          </div>
        </div>

        <!-- Desktop: All in one row -->
        <div class="desktop-layout">
          <div class="daily-deal-title-desktop">DAILY DEAL</div>
          <div class="timer-row">
            <div v-if="!isDailyDeal" class="timer-item">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Days</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ days }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Hours</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ hours }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Minutes</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ minutes }}</div>
            </div>
            <div class="timer-item">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Seconds</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ seconds }}</div>
            </div>
          </div>
          <div v-if="enableClose" class="close-icon-desktop">
            <i class="las la-times la-m2x" style="cursor: pointer" @click="close"></i>
          </div>
        </div>
      </div>

      <!-- Non-daily deal layout -->
      <div v-if="!isDailyDeal" class="regular-timer-container">
        <div class="home-banner-copy-wrapper">
          <div v-if="enableContent" class="home-banner-copy">
            <slot name="content"></slot>
          </div>
          <div class="timer-row home-banner-row">
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Days</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ days }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Hours</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ hours }}</div>
            </div>
            <div class="timer-item timer-border">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Minutes</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ minutes }}</div>
            </div>
            <div class="timer-item">
              <div :class="`timer-text ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">Seconds</div>
              <div :class="`timer-number ${isDailyDeal? 'dailyDealBanner' : 'homePageBanner'}`">{{ seconds }}</div>
            </div>
          </div>
        </div>
        <div v-if="enableClose" class="close-icon-desktop">
          <i class="las la-times la-m2x" style="cursor: pointer" @click="close"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDailyDeal: false,
    dailyDealDate: { required: true },
    backgroundColor: { required: true },
    textColor: { required: true },
    enableClose: { type: Boolean, required: false, default: false },
    enableContent: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      displayTimerBar: true,
      startDate: new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      ),
      endDate: this.getEndDate(),
      currentTime: null,
      isRunning: false,
      increaseTimer: 0
    }
  },
  computed: {
    days() {
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const days = Math.floor(remainingSeconds / 86400) // 86400 seconds in a day
        return `${days.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    hours() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const hours = Math.floor((remainingSeconds % 86400) / 3600)
        return `${hours.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    minutes() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate) || !this.dailyDealDate) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const minutes = Math.floor((remainingSeconds % 3600) / 60)
        return `${minutes.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    },
    seconds() {
      this.increaseTimer
      if ((this.currentTime && this.currentTime > this.endDate)) {
        return "00"
      } else if (this.currentTime) {
        const remainingSeconds = Math.floor((this.endDate - this.currentTime) / 1000)
        const seconds = remainingSeconds % 60
        return `${seconds.toString().padStart(2, "0")}`
      } else {
        return "00"
      }
    }
  },
  watch: {
    isRunning(newValue) {
      if (newValue) {
        this.currentTime = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
        )
      }
    },
    dailyDealDate() {
    }
  },
  methods: {
    startCountdown() {
      this.isRunning = true
      this.updateCountdown()
    },
    stopCountdown() {
      this.isRunning = false
    },
    updateCountdown() {
      if (this.isRunning) {
        this.currentTime = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
        )
        this.increaseTimer++
        if (this.currentTime > this.endDate) {
          this.isRunning = false
          return
        }
        requestAnimationFrame(this.updateCountdown)
      }
    },
    getEndDate() {
      let endDate = new Date(this.dailyDealDate ? this.dailyDealDate : new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
      ))
      endDate = endDate.setDate(endDate.getDate() + 1)
      return endDate
    },
    close() {
      this.displayTimerBar = false
    }
  },
  mounted() {
    this.startCountdown()
  }
}
</script>

<style scoped lang="scss">
/* Daily Deal Container */
.daily-deal-container {
  width: 100%;
}

/* Mobile Layout - Show on small screens */
.mobile-layout {
  display: block;
  width: 100%;
  text-align: center;
}

.daily-deal-title {
  color: #fff;
  margin: 0 0 10px 0;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
}

/* Desktop Layout - Hidden on small screens */
.desktop-layout {
  display: none;
}

.daily-deal-title-desktop {
  color: #fff;
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

/* Timer Row */
.timer-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}

.timer-item {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  min-width: 60px;
}

.timer-border {
  border-right: 2px solid white;
}

/* Close Icons */
.close-icon-mobile {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  cursor: pointer;
}

.close-icon-desktop {
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
}

/* Regular Timer Container (non-daily deal) */
.regular-timer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.home-banner-copy-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.home-banner-copy ::v-deep p {
  margin: 0;
}

/* Existing Timer Styles */
.timer {
  color: white;
  background: orange;

  &.homePageBanner {
    min-height: 46px;
    padding-top: 2px;
    padding-bottom: 2px;
    display: flex;
    place-items: center;
  }
}

.timer-number {
  font-size: 1.2rem;
  font-weight: 600;
  &.homePageBanner {
    font-size: 14px;
  }
}

.timer-text {
  font-size: 1rem;
  text-transform: uppercase;
  &.homePageBanner {
    font-size: 10px;
  }
}

/* Desktop Media Query - 768px and above */
@media screen and (min-width: 768px) {
  .mobile-layout {
    display: none;
  }

  .desktop-layout {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .daily-deal-title-desktop {
    flex-shrink: 0;
  }

  .timer-row {
    flex-shrink: 0;
  }

  .close-icon-desktop {
    flex-shrink: 0;
  }
}

/* Mobile-specific adjustments */
@media screen and (max-width: 767px) {
  .daily-deal-title {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }

  .timer-item {
    padding: 0 8px;
    min-width: 50px;
  }

  .timer-number {
    font-size: 1rem;
    &.homePageBanner {
      font-size: 12px;
    }
  }

  .timer-text {
    font-size: 0.9rem;
    &.homePageBanner {
      font-size: 9px;
    }
  }

  .regular-timer-container {
    flex-wrap: nowrap;
  }

  .home-banner-copy-wrapper {
    flex-wrap: nowrap;
    gap: 6px;
  }

  .home-banner-row {
    flex-wrap: nowrap;
  }

  .regular-timer-container .timer-item {
    padding: 0 5px;
    min-width: auto;
  }

  .home-banner-copy {
    font-size: 12px;
    white-space: nowrap;

    ::v-deep * {
      font-size: 12px !important;
    }
  }
}

/* Very small screens */
@media screen and (max-width: 480px) {
  .daily-deal-title {
    font-size: 1.5rem;
  }

  .timer-item {
    padding: 0 6px;
    min-width: 45px;
  }

  .regular-timer-container .timer-item {
    padding: 0 4px;
    min-width: auto;
  }

  .timer-number {
    &.homePageBanner {
      font-size: 11px;
    }
  }

  .timer-text {
    &.homePageBanner {
      font-size: 8px;
    }
  }

  .home-banner-copy {
    font-size: 11px;

    ::v-deep * {
      font-size: 11px !important;
    }
  }

  .la-m2x {
    font-size: 1.7rem;
  }
}
</style>
